<template>
  <div class="restaurantBookSet">
    <div class="title">
      <div>{{$route.meta.title}}</div>
      <Select :defaultValue="restaurant" @input="restaurant=$event" :width="'300px'">
        <option :value="null">商店列表</option>
        <option v-for="(rest, r) in restaurants" :key="r" :value="rest">{{rest}}</option>
      </Select>
      <RT :style="{marginLeft: 'auto'}"  v-if="restaurant&&restaurantInfo.storeType==='restaurant'" :options="options"
      :defaultValue="page" @input="$router.replace({ name: $route.name, query: { page: $event } })"></RT>
      <RT :style="{marginLeft: 'auto'}"  v-else-if="restaurant&&restaurantInfo&&restaurantInfo.storeType==='shop'" :options="options"
      :defaultValue="page" @input="$router.replace({ name: $route.name, query: { page: $event } })"></RT>
      <RT :style="{marginLeft: 'auto'}"  v-else-if="restaurant" :options="options"
      :defaultValue="page" @input="$router.replace({ name: $route.name, query: { page: $event } })"></RT>
    </div>
    <template v-if="restaurant">
      <restBookSet :info="restaurantInfo" v-if="page==='預約須知'" @update="update"/>
      <restBookSummarySet :info="restaurantInfo" v-else-if="page==='時段設定'" @update="update"/>
      <restBookSummarySet2 :info="restaurantInfo" v-else-if="page==='預約限制'" @update="update"/>
      <restBookSummarySet2v2 :info="restaurantInfo" v-else-if="page==='自取設定'" @update="update"/>
      <restBookSummarySet3v2 :info="restaurantInfo" v-else-if="page==='宅配設定'" @update="update"/>
      <textMessageTemplate :info="restaurantInfo" v-else-if="page==='簡訊模板'" @update="update"/>
      <productMode :info="restaurantInfo" :mode="restaurantInfo.mode" v-else-if="page==='手機顯示排列'"
      @update="update"/>
      <PosReceiptVue :info="restaurantInfo" v-else-if="page==='POS出單顯示'" @update="update"/>
      <restInvoiceItemsVue :info="restaurantInfo" v-else-if="page==='發票開立品項'" @update="update"/>
      <div v-if="page==='成分標籤'">
        <div class="LabelInfos">
          <editCube :style="{border:'none'}" :edit="edit" @edit="edit=$event" @save="save"
          :label="'商品標籤樣板'">
            <div class="fieldsIng">
              <div v-for="(info, i) in (labelSample || [])" :key="`info-${i}`">
                <div><span v-for="n in info.name" :key="`info-${i}-${n}`">{{n}}</span></div>
                <div :style="{textAlign:'center'}">:</div>
                <div>{{info.value||'-'}}</div>
              </div>
            </div>
            <div class="fieldsIngEdit" slot="edit">
              <div v-for="(info, i) in labelSampleEdit" :key="`info-${i}`">
                <button class="remove" @click="labelSampleEdit.splice(i, 1)"></button>
                <button class="add" @click="labelSampleEdit.splice(i+1, 0, { name: '', value: '' })"></button>
                <input type="text"  v-model="labelSampleEdit[i].name">
                <div :style="{textAlign:'center'}">:</div>
                <input type="text" v-model="labelSampleEdit[i].value">
              </div>
            </div>
          </editCube>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="listRest" :style="{gridTemplateColumns: [...[tickets, rests, shops].filter(e => e.length>0).map(() => '390px'), '1fr'].join(' ')}">
        <div class="mobile" label="園區" v-if="tickets.length>0">
        <SaveBtn @click="saveOrder('tickets')" :style="{ position: 'absolute', top: '10px', right: '15px' }" v-if="currentTickets!==defaultTickets"/>
        <vuedraggable v-model="tickets">
          <div v-for="(rest, r) in tickets" :key="`ticket-${r}`">
            <div class="img" :style="{backgroundImage: `url(.${rest.restBookImage})`}"></div>
            <div>
              {{rest.name}}
              <SwitchBox class="switchposition" :defaultValue="rest.online" @update="update1(rest.name, { online: $event })"/>
            </div>
            <div>{{rest.description}}</div>
          </div>
        </vuedraggable>
        </div>
        <div class="mobile" label="餐廳" v-if="rests.length>0">
        <SaveBtn @click="saveOrder('rests')" :style="{ position: 'absolute', top: '10px', right: '15px' }" v-if="currentRests!==defaultRests"/>
        <vuedraggable v-model="rests">
          <div v-for="(rest, r) in rests" :key="`restaurant-${r}`">
            <div class="img" :style="{backgroundImage: `url(.${rest.restBookImage})`}"></div>
            <div>
              {{rest.name}}
              <SwitchBox class="switchposition" :defaultValue="rest.online" @update="update1(rest.name, { online: $event })"/>
            </div>
            <div>{{rest.description}}</div>
          </div>
        </vuedraggable>
        </div>
        <div class="mobile" label="商店" v-if="shops.length>0">
        <SaveBtn @click="saveOrder('shops')" :style="{ position: 'absolute', top: '10px', right: '15px' }" v-if="currentShops!==defaultShops"/>
        <vuedraggable v-model="shops">
          <div v-for="(rest, r) in shops" :key="`shop-${r}`">
            <div class="img" :style="{backgroundImage: `url(.${rest.restBookImage})`}"></div>
            <div>
              {{rest.name}}
              <SwitchBox class="switchposition" :defaultValue="rest.online" @update="update1(rest.name, { online: $event })"/>
            </div>
            <div>{{rest.description}}</div>

          </div>
        </vuedraggable>
        </div>
        <div :style="{overflowY: 'auto', maxHeight: 'calc(100vh - 90px)'}">
          <div :style="{
            height: '70px', marginTop: 0, padding: '10px 20px',
            alignItems:'center', justifyContent:'flex-start', display:'flex', flexDirection: 'row', gap: '20px'
          }">
            <div :style="{fontSize: '24px', color:'var(--color-pri)'}">其他付款方式</div>
            <!-- <RT :defaultValue="needInvoice==='Y' ? '付款方式' : needInvoice==='N' ? '禮券' : '折價券'"
            @input="needInvoice=$event === '付款方式' ? 'Y' : $event === '禮券' ? 'N' : 'X'"
            :options="['付款方式', '禮券', '折價券']"/> -->
            <!-- <SQRBtn @click="addpaymethod={
              ID: null,
              description: null,
              enableChange:false,
              enabledMultiple:true,
              enabledUse:true,
              fixedAmount:0,
              invoiceDescription:'需開立發票',
              name: null,
              needInvoice: 'Y',
              pointAccumulated:true
            }" :icon="'add'" :iconSize="'23'" :bg="'var(--color-checked)'" :style="{marginLeft:'auto', width: '45px', padding: 0}"/> -->
          </div>
          <Table :rows="payMethod.filter(e => e.needInvoice===this.needInvoice)">
            <template slot="slot_head">
              <th>編號</th>
              <th :style="{textAlign:'start'}">名稱 <span :style="{fontSize: '14px', color: '#CACACA', lineHeight: '1em'}"> (敘述)</span></th>
              <th>顯示</th>
              <th>ERP可用</th>
              <th>多元</th>
              <th>需發票</th>
              <th>固定金額</th>
            </template>
            <tr slot-scope="{item}">
              <td class="tdID">
                <div>{{item.ID}}</div>
                <!-- <DelBtn @click="deletePayMethods(item.ID)"></DelBtn> -->
              </td>
              <td :style="{textAlign:'start'}">{{item.name}}<span :style="{fontSize: '14px', color: '#CACACA', lineHeight: '1em'}"><br>{{item.description}}</span></td>
              <td @click="updatePayMethods(item.ID, !payMethodHide.includes(item.ID))"><div :class="!payMethodHide.includes(item.ID) ? 'posCheck' : 'posUncheck'"></div></td>
              <td>{{item.enabledUse ? 'O' : ''}}</td>
              <td>{{item.enabledMultiple ? 'O' : ''}}</td>
              <td>{{item.needInvoice === 'Y' ? 'O' : 'X'}}</td>
              <td>{{item.fixedAmount || '-'}}</td>
            </tr>
          </Table>
        </div>
      </div>
      <dialognoPadding2Vue :label="'新增付款方式'" v-if="addpaymethod" :show="addpaymethod" @close="addpaymethod=null">
        <div :style="{padding: '20px 40px'}" class="dialogPay">
          <div class="frow">
            <div class="field"><div>ID</div><NormalInput :defaultValue="addpaymethod.ID" @input="addpaymethod.ID=$event " :width="'160px'"/></div>
            <div class="field"><div>固定價格</div><NumInput :defaultValue="addpaymethod.fixedAmount" @input="addpaymethod.fixedAmount=$event " :width="'100px'" :center="true"/></div>
          </div>
          <div class="field"><div>名稱</div><NormalInput :defaultValue="addpaymethod.name" @input="addpaymethod.name=$event " :width="'300px'"/></div>
          <div class="field"><div>敘述</div><NormalInput :defaultValue="addpaymethod.description" @input="addpaymethod.description=$event " :style="{width: '100%'}"/></div>
          <BtnsS :style="{marginTop: '30px', marginInline:'auto'}" @cancel="addpaymethod=null" @save="addPaymethodFn"/>
        </div>
      </dialognoPadding2Vue>
    </template>
  </div>
</template>

<script>
import editCube from './editBox.vue'
import NumInput from '../../components/input/number.vue'
import NormalInput from '../../components/input/normal.vue'
import textMessageTemplate from './textMessageTemplate.vue'
import SwitchBox from '../../components/radio/switch.vue'
import vuedraggable from 'vuedraggable'
import SaveBtn from '../../components/btn/save.vue'
import { mapState } from 'vuex'
import { getapi, postapi } from '../../store/fetch'
import Select from '../../components/select.vue'
import restBookSet from './restbookset.vue'
import restBookSummarySet2 from './restBookSummarySet2.vue'
import restBookSummarySet2v2 from './restBookSummarySetShop_v2.vue'
import restBookSummarySet3v2 from './restBookSummarySetShopDeliver_v2.vue'
import restBookSummarySet from './restBookSummarySet.vue'
import productMode from './productMode.vue'
import PosReceiptVue from './posReceipt.vue'
import restInvoiceItemsVue from './restInvoiceItems.vue'
import Table from '../../components/tables/t2.vue'
const production = !(/dev/i.test(location.origin) || /localhost/i.test(location.origin))
export default {
  name: 'restaurantBookSet',
  components: {
    editCube,
    restBookSummarySet2v2,
    restBookSummarySet3v2,
    textMessageTemplate,
    Table,
    SwitchBox,
    PosReceiptVue,
    restBookSet,
    restBookSummarySet,
    restBookSummarySet2,
    productMode,
    Select,
    vuedraggable,
    SaveBtn,
    restInvoiceItemsVue,
    NumInput,
    NormalInput
  },
  computed: {
    ...mapState({
      restaurants: 'restaurants',
      defaultStore: 'defaultStore',
      restaurantsInfos: 'restaurantsInfos'
    }),
    options () {
      switch (this.restaurantInfo.storeType) {
        case 'restaurant':
          return production ? ['預約須知', '簡訊模板', '預約限制', '時段設定', '手機顯示排列', 'POS出單顯示', '發票開立品項']
            : ['預約須知', '簡訊模板', '預約限制', '時段設定', '手機顯示排列', 'POS出單顯示', '發票開立品項']
        case 'shop':
          return ['預約須知', '簡訊模板', '自取設定', '宅配設定', '手機顯示排列', '發票開立品項', '成分標籤']
        default:
          return ['預約須知', '簡訊模板', '時段設定']
      }
    },
    page () {
      return this.$route.query.page
    },
    defaultRests () {
      return this.restaurantsInfos.filter(e => e.storeType === 'restaurant').map(e => e.name).join('_')
    },
    defaultShops () {
      return this.restaurantsInfos.filter(e => e.storeType === 'shop').map(e => e.name).join('_')
    },
    defaultTickets () {
      return this.restaurantsInfos.filter(e => e.storeType === 'tickets').map(e => e.name).join('_')
    },
    currentRests () {
      return this.rests.map(e => e.name).join('_')
    },
    currentShops () {
      return this.shops.map(e => e.name).join('_')
    },
    currentTickets () {
      return this.tickets.map(e => e.name).join('_')
    }
  },
  data () {
    return {
      production,
      restaurant: null,
      restaurantInfo: null,
      rests: [],
      shops: [],
      tickets: [],
      payMethod: [],
      payMethodHide: [],
      needInvoice: 'Y',
      addpaymethod: null,
      labelSample: [],
      labelSampleEdit: [],
      edit: false
    }
  },
  async mounted () {
    this.restaurant = this.defaultStore || this.restaurants[0]
    this.rests = this.restaurantsInfos.filter(e => e.storeType === 'restaurant')
    this.shops = this.restaurantsInfos.filter(e => e.storeType === 'shop')
    this.tickets = this.restaurantsInfos.filter(e => e.storeType === 'tickets')
    this.payMethod = await getapi('selections/payMethod')
    this.payMethodHide = (await getapi('selections/payMethodHide')) || []
    const labelSample = await getapi('selections/LabelSample')
    if (labelSample && labelSample.length > 0) {
      this.labelSample = labelSample
    } else {
      this.labelSample = [{ name: '品名', value: '{name}' }]
    }
  },
  methods: {
    async updatePayMethods (ID, bool) {
      let payMethodHide = this.payMethodHide
      if (bool) {
        payMethodHide.push(ID)
      } else {
        payMethodHide = payMethodHide.filter(e => e !== ID)
      }
      Array.from(new Set(payMethodHide))
      this.payMethodHide = await postapi('selections/payMethodHide', { key: 'options', data: payMethodHide })
    },
    async addPaymethodFn () {
      const payMethod = JSON.parse(JSON.stringify(this.payMethod))
      payMethod.push(this.addpaymethod)
      this.payMethod = await postapi('selections/payMethod', { key: 'optionsObj', data: payMethod })
      this.addpaymethod = null
    },
    async deletePayMethods (ID) {
      const payMethod = JSON.parse(JSON.stringify(this.payMethod))
      const index = payMethod.map(e => e.ID).indexOf(ID)
      payMethod.splice(index, 1)
      this.payMethod = await postapi('selections/payMethod', { key: 'optionsObj', data: payMethod })
    },
    async update1 (name, ev) {
      const r = await postapi(`restaurantSetting/${name}`, ev)
      this.restaurantInfo = r
      const restaurantsInfos = JSON.parse(JSON.stringify(this.restaurantsInfos))
      const index = restaurantsInfos.map(e => e.name).indexOf(name)
      console.log('update', index, ev)
      restaurantsInfos.splice(index, 1, r)
      this.$store.commit('setRestaurants', restaurantsInfos)
      console.table(restaurantsInfos)
      this.rests = this.restaurantsInfos.filter(e => e.storeType === 'restaurant')
      this.shops = this.restaurantsInfos.filter(e => e.storeType === 'shop')
      this.tickets = this.restaurantsInfos.filter(e => e.storeType === 'tickets')
    },
    async update (ev) {
      if (this.restaurant) {
        const r = await postapi(`restaurantSetting/${this.restaurant}`, ev)
        this.restaurantInfo = r
        const restaurantsInfos = JSON.parse(JSON.stringify(this.restaurantsInfos))
        const index = restaurantsInfos.map(e => e.name).indexOf(this.restaurant)
        console.log('update', index, ev)
        restaurantsInfos.splice(index, 1, r)
        this.$store.commit('setRestaurants', restaurantsInfos)
        console.table(restaurantsInfos)
        this.rests = this.restaurantsInfos.filter(e => e.storeType === 'restaurant')
        this.shops = this.restaurantsInfos.filter(e => e.storeType === 'shop')
        this.tickets = this.restaurantsInfos.filter(e => e.storeType === 'tickets')
      }
    },
    async saveOrder (key) {
      const r = await postapi('restaurantSetting/order', {
        order: this[key].map(e => e._id)
      })
      if (r) {
        const restaurants = await getapi('restaurantSetting/all')
        this.$store.commit('setRestaurants', restaurants)
      }
    },
    async updateSelection (key, opt, ev) {
      this[key] = await postapi(`selections/${key}`, { key: opt, data: ev })
    },
    async save () {
      await this.updateSelection('LabelSample', 'optionsObj', this.labelSampleEdit)
      this.labelSample = await getapi('selections/LabelSample')
      this.edit = false
    }
  },
  watch: {
    edit () {
      if (this.edit) {
        this.labelSampleEdit = JSON.parse(JSON.stringify(this.labelSample))
      }
    },
    restaurant: {
      async handler () {
        if (this.restaurant) {
          this.restaurantInfo = await getapi(`restaurantSetting/${this.restaurant}`)
        }
        if (!this.options.includes(this.page)) {
          this.$router.replace({ name: this.$route.name, query: { page: this.options[0] } })
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.fieldsIngEdit {
  font-size: 20px;
  max-width: calc(100vw - 1155px);
  &>div{
    display: grid;
    grid-template-columns: 40px 40px 4em 1em 1fr;
  }
  button {
    width: 1em;
    height: 1em;
    mask-position: center;
    mask-size: contain;
    background-color: #CACACA;
    mask-repeat: no-repeat;
    &.remove {
      &:hover {background-color: var(--highlight);}
      mask-image: url(/svg/btn/del1.svg);
    }
    &.add {
      &:hover {background-color: var(--color-pri);}
      mask-image: url(/svg/btn/add.svg);
    }
  }
}
.fieldsIng {
  display: flex;
  flex-direction: column;
  text-align: start;
  font-size: 20px;
  color: var(--color-pri);
  &>div{
    display: grid;
    grid-template-columns: 4em 1em 1fr;
    &>div:nth-child(1) {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
    }
  }
}
.LabelInfos {
  width: 600px;
  padding: 25px 53px 25px 52px;
}
.posCheck {
  mask-image: url(./svg/auth/visibility.svg);
  background-color: #ff8b8b;
  width: 25px;
  height: 25px;
  mask-size: contain;
  margin-inline: auto;
}
.posUncheck {
  mask-image: url(./svg/auth/visibility_off.svg);
  background-color: #CACACA;
  width: 25px;
  height: 25px;
  mask-size: contain;
  margin-inline: auto;
}
.frow {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
}
.dialogPay {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 20px;
}
.field {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  &>div:nth-child(1) {
    display: inline-flex;
    width: 5em;
    min-width: 5em;
  }
}
.tdID {
  // &>button {
  //   display: none;
  //   margin: auto;
  // }
  // &:hover {
  //   &>div {
  //     display: none;
  //   }
  //   &>button {
  //     display: block;
  //   }
  // }
}
.switchposition {
  margin-left: auto;
  margin-right: 10px;
}
.listRest {
  display: grid;
  max-height: calc(100vh - 90px);
  position: relative;
  &>div:not(:last-child){
    border-right: 1px solid #CACACA;
  }
  &>.mobile{
    position: relative;
    &::before {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 55px;
      content: attr(label);
      display: inline-flex;
      background-color: var(--color-pri);
      color: #FFFFFF;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      letter-spacing: 2px;
      font-weight: 500;
    }
  }
  &>div.mobile>div{
    overflow-y: auto;
    margin-top: 55px;
    padding: 20px 20px 20px 20px;
    max-height: calc(100vh - 145px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    overflow-y: auto;
    position: relative;
    &>div{
      position: relative;
      width: 332px;
      height: 290px;
      background: #FFFFFF;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      border-radius: 10px;
      text-align: start;
      padding: 15px;
      gap: 10px;
      .img {
        width: 100%;
        height: 205px;
        background-position: center;
        background-size: cover;
        background-repeat: no-repeat;
        background-color: #CACACA;
        border-radius: 3px;
      }
      &>div:nth-child(2) {
        font-size: 18px;
        color: var(--color-pri);
        font-weight: 400;
        letter-spacing: .1em;
        line-height: 32.4px;
        display: flex;
        width: 100%;

      }
      &>div:nth-child(3) {
        font-size: 14px;
        color: #8C8C8C;
        font-weight: 400;
        line-height: 25.2px;
      }
    }
  }
}
.restaurantBookSet {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 89px 1fr;
  height: 100%;
}
.title > input[type=radio] {
  width: 120px;
  height: 40px;
  appearance: none;
  background-color: var(--color-border);
  color: #FFFFFF;
  border-radius: 3px;
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  letter-spacing: 0.1em;
  display: flex;
  align-items: center;
  justify-content: center;
  &::before {
    content: attr(value);  }

  &:checked {
    background-color: var(--color-pri);
  }

}
.title {
  margin-inline: 20px;
  background-color: #FFF;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 20px;
  &::before {
    content: '';
    display: inline-flex;
    width: 55px;
    height: 55px;
    mask-image: url(./setting.svg);
    mask-repeat: no-repeat;
    mask-position: center;
    background-color: var(--color-pri);
  }
  height: 89px;
  display: flex;
  align-items: center;
  font-family: Noto Sans TC;
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  letter-spacing: 0.15em;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-pri);
  gap: 10px;
}
</style>
